import Alert from '@storeblocks/alert';
import { WrapLgMarginBottom } from 'App/global-style';
import { useFormStatus } from 'Forms/forms.hooks';
import React from 'react';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import { shouldHaveFutureCancelDateAkaStudent } from '../cancelAkaStudentForm.helpers';
import { CancelAkaStudentFormValues } from '../cancelAkaStudentForm.types';

interface CancelAkaStudentFormAlertsProps {
  formValues: CancelAkaStudentFormValues;
  isSubmitting: boolean;
}

export const CancelAkaStudentFormAlerts = ({
  formValues,
  isSubmitting,
}: CancelAkaStudentFormAlertsProps): React.ReactElement | null => {
  const { cancelReason } = formValues;
  const { submitSuccess } = useFormStatus();

  if (
    !isDefined(cancelReason) ||
    isSubmitting ||
    submitSuccess ||
    shouldHaveFutureCancelDateAkaStudent(cancelReason)
  ) {
    return null;
  }

  return (
    <WrapLgMarginBottom>
      <Alert
        title={getAppText('cancel.cancelReason.alert.title.renewalCancel')}
        description={getAppText(
          'cancel.akaStudent.cancelReason.alert.description.renewalCancel',
        )}
      />
    </WrapLgMarginBottom>
  );
};
